<h1 class="container-heading">Carrier services mapping</h1>
<mat-card>
    <mat-card-content>
        <common-table2 *ngIf="listTable" [settings]="listTable">
            <div class="flex row" row1>
                <button type="button" color="accent" mat-raised-button (click)="add()">
                    Add
                </button>
            </div>
        </common-table2>
    </mat-card-content>
</mat-card>
<common-confirm></common-confirm>